import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]

import {computed} from "vue";
import Tile from "./Tile.vue";

interface Props {
  title?: string;
  space?: boolean;
  border?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    title: {},
    space: { type: Boolean },
    border: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const border = computed(() => {
  if (props.border) {
    return 'rounded-lg border border-tile-border';
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, {
    vertical: "",
    space: "",
    "big-space": props.space,
    class: _normalizeClass(border.value)
  }, {
    default: _withCtx(() => [
      (props.title)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "text-lg font-semibold",
            textContent: _toDisplayString(props.title)
          }, null, 8 /* PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["big-space", "class"]))
}
}

})